import { resolveNavigationItems } from "./navigation.js";
import { pageHref } from "./pagePresentation.js";

export const footerPositions = ["col1", "col2", "col3", "col4"];

export function managedFooterColumns(settings, pages = [], categories = []) {
  const links = resolveNavigationItems(settings.navigation?.footer, settings, categories, pages);
  const flatten = (rows, parent = "col1") => rows.flatMap(row => {
    const position = row.footerPosition || parent;
    return [{ ...row, footerPosition: position, children: [] }, ...flatten(row.children || [], position)];
  });
  const flat = flatten(links);
  return footerPositions.map(position => flat.filter(row => row.footerPosition === position));
}

export function automaticFooterColumns(settings, pages = []) {
  return footerPositions.map(position => pages.filter(page => page.publicationId === settings.publicationId && !page.deletedAt && page.footerPosition === position)
    .map(page => ({ id: page.id, label: page.title, type: "page", target: page.id, href: pageHref(page, settings), footerPosition: position })));
}

// Convert the currently visible footer into editable references without copying another publication's records.
export function footerLinksForSave(columns, settings, pages, categories) {
  return columns.flatMap((column, index) => column.map(item => {
    const owned = rows => rows.filter(row => row.publicationId === settings.publicationId && !row.deletedAt);
    const page = owned(pages).find(row => row.id === item.target || row.id === item.id || pageHref(row, settings) === item.href);
    const category = owned(categories).find(row => row.id === item.target || row.id === item.id);
    return { id: item.id || crypto.randomUUID(), label: item.label, footerPosition: footerPositions[index], children: [],
      ...(page ? { type: "page", target: page.id } : category ? { type: "category", target: category.id } : { type: "custom_url", url: item.href || item.url }) };
  }));
}
